import schoolService from '../services/school.service';
import type { ThunkAction } from './common.actionTypes';
import {
	GET_STRIPE_SCHOOL_SEATS,
	GET_STRIPE_SCHOOL_TEACHERS,
	type GetStripeSchoolSeatsAction,
	type GetStripeSchoolTeachersAction,
} from './stripeSchoolTeachers.actionTypes';

export function getStripeSchoolTeachers(
	schoolId: string,
	page = 1,
	pageSize = 50,
	search = ''
): ThunkAction<GetStripeSchoolTeachersAction> {
	return async (dispatch, getState) => {
		const me = getState().user.me;
		if (!me || !me.rights?.schoolAdmin) {
			return;
		}

		dispatch({ type: GET_STRIPE_SCHOOL_TEACHERS.START });

		return schoolService
			.getStripeSchoolTeachers(schoolId, page, pageSize, search)
			.then((result) => dispatch({ type: GET_STRIPE_SCHOOL_TEACHERS.SUCCESS, result }))
			.catch((error) => dispatch({ type: GET_STRIPE_SCHOOL_TEACHERS.ERROR, error }));
	};
}

export function getStripeSchoolSeats(schoolId: string): ThunkAction<GetStripeSchoolSeatsAction> {
	return async (dispatch) => {
		dispatch({ type: GET_STRIPE_SCHOOL_SEATS.START });

		return schoolService
			.getStripeSchoolSeats(schoolId)
			.then((result) => dispatch({ type: GET_STRIPE_SCHOOL_SEATS.SUCCESS, result }))
			.catch((error) => dispatch({ type: GET_STRIPE_SCHOOL_SEATS.ERROR, error }));
	};
}
